import React from "react";
var __jsx = React.createElement;
import { useState, forwardRef } from "react";
import stl from "./Input.module.css";
import useIsIOS from "@hooks/useIsIOS";
import { CDN_LINK } from "@globalConfig";
var Input = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var type = _ref.type,
    name = _ref.name,
    id = _ref.id,
    value = _ref.value,
    autoComplete = _ref.autoComplete,
    autoFocus = _ref.autoFocus,
    disabled = _ref.disabled,
    maxLength = _ref.maxLength,
    minLength = _ref.minLength,
    className = _ref.className,
    placeholder = _ref.placeholder,
    extraInfo = _ref.extraInfo,
    error = _ref.error,
    onlyNumbers = _ref.onlyNumbers,
    topLabel = _ref.topLabel,
    smallerWidth = _ref.smallerWidth,
    note = _ref.note,
    inputTitle = _ref.inputTitle,
    label = _ref.label,
    ariaLabel = _ref.ariaLabel,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$onFocus = _ref.onFocus,
    _onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    _onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    _ref$onKeyDown = _ref.onKeyDown,
    _onKeyDown = _ref$onKeyDown === void 0 ? function (e) {} : _ref$onKeyDown,
    inputMode = _ref.inputMode,
    _ref$inputClassName = _ref.inputClassName,
    inputClassName = _ref$inputClassName === void 0 ? '' : _ref$inputClassName,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly;
  var _useState = useState(false),
    isFocused = _useState[0],
    setIsFocused = _useState[1];
  var _useState2 = useState(false),
    showPassword = _useState2[0],
    setShowPassword = _useState2[1];
  var isIos = useIsIOS();

  // Function to determine the input type based on props
  var myType = function myType() {
    switch (type) {
      case "number":
        return isIos ? "text" : "number";
      case "password":
        return showPassword ? "text" : "password";
      default:
        return "text";
    }
  };
  var orginalType = type;
  var isTargeted = isFocused || value || value === 0 || placeholder;
  var handleChange = function handleChange(e) {
    // Convert Arabic digits to English digits
    var arabicToEnglish = function arabicToEnglish(value) {
      return value.replace(/[٠١٢٣٤٥٦٧٨٩]/g, function (d) {
        return String(d.charCodeAt(0) - 1632);
      });
    };
    var val = arabicToEnglish(e.target.value);

    // Restrict input to only numbers if onlyNumbers is true
    if (onlyNumbers && !val.match(/^[0-9]*$/)) {
      return; // Prevent invalid input
    }

    // Limit the length of the value
    if (maxLength && val.length > maxLength) {
      e.target.value = val.slice(0, maxLength);
    } else {
      e.target.value = val; // Update the input value with converted value
    }

    // Call the onChange prop with the updated value
    onChange(e);
  };
  var handleTextClick = function handleTextClick() {
    var _ref$current;
    if (isTargeted) return;
    ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.inputWrapper, " ").concat(isTargeted ? stl.targeted : "", " ").concat(error ? stl.hasError : "", " ").concat(className ? className : "", " ").concat(isFocused ? stl.focused : "", " ").concat(disabled ? stl.disabled : "")
  }, /*#__PURE__*/React.createElement("input", {
    ref: ref,
    type: myType(),
    inputMode: inputMode,
    pattern: orginalType === "number" || onlyNumbers ? "[0-9]*" : undefined,
    name: name,
    id: id,
    value: value,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    disabled: disabled,
    maxLength: maxLength,
    minLength: minLength,
    readOnly: readOnly,
    onKeyDown: function onKeyDown(e) {
      _onKeyDown(e);
      if (type === "number" && (e.key === "e" || e.key === "E")) return e.preventDefault();
      if (orginalType === "number") {
        // Allow control keys
        var allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];

        // Check for valid number input
        var isNumberKey = function isNumberKey(key) {
          var isEnglishNumber = key >= "0" && key <= "9";
          var isArabicNumber = key >= "\u0660" && key <= "\u0669";
          return isEnglishNumber || isArabicNumber;
        };

        // Prevent invalid keypresses
        if (!allowedKeys.includes(e.key) && !isNumberKey(e.key)) {
          e.preventDefault();
        }
      }
    },
    onChange: handleChange,
    onFocus: function onFocus() {
      _onFocus();
      setIsFocused(true);
    },
    onBlur: function onBlur() {
      _onBlur();
      setIsFocused(false);
    },
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : label ? String(label) : undefined,
    placeholder: placeholder,
    className: inputClassName
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.label,
    onClick: handleTextClick
  }, label, /*#__PURE__*/React.createElement("span", {
    className: stl.inputLabelFloating
  })), topLabel && /*#__PURE__*/React.createElement("span", {
    className: stl.topLabel,
    onClick: handleTextClick
  }, topLabel), extraInfo && /*#__PURE__*/React.createElement("span", {
    className: stl.extraInfo,
    onClick: handleTextClick
  }, extraInfo), type === "password" && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "".concat(stl.togglePassword, " hasEvents"),
    onClick: function onClick() {
      return setShowPassword(function (pre) {
        return !pre;
      });
    },
    "aria-label": "toggle password visibility"
  }, /*#__PURE__*/React.createElement("img", {
    src: !showPassword ? CDN_LINK + "/assets/images/visibilityEye.svg" : CDN_LINK + "/assets/images/visibilityEyeBlue.svg",
    alt: "Toggle password visibility"
  })), error && /*#__PURE__*/React.createElement("span", {
    className: stl.error
  }, error), !error && note && /*#__PURE__*/React.createElement("span", {
    className: stl.note
  }, note));
});
export default Input;